<pre>
  App 1 Online:
  Environment: {{environment}}
  https://itai-nx-test-app1.web.app/
  Tested:
  Nx migrations
  Nx linting
  Nx testing
  Translation configuration
  Nx shared libs (simple headers like, but also pipes, and config.json readers)
  Nx vs code extensions (a must for devs)
  Error handling
  Ngrx with nx
  Messages to User (toaster that is dismissed on route changes - and configurable)
  Caching (configurable with timer - can make a full demo, with backend included)
  Logging (reading config from a file)
  Stepper
  Azure nx dev deployments (storage, static and node app services)
  Hash vs push location strategy
</pre>

<nxt-nx-welcome></nxt-nx-welcome>

<a href="mailto:email@example.com">Send Email</a>
